import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { hidePopup } from "../../store/popupSlice";

const Popup = () => {
    const dispatch = useDispatch();
    const alert = useSelector(state => state.popup);

    const handleAlertHide = (el, idx) => {
        el.onClickBtn();
        dispatch(hidePopup(idx));
    }
    return (
        alert.value.map((el, idx) => {
            return (
                <Modal key={idx} show={el.state} 
                    centered 
                    size="sm"
                    backdrop={el.backdrop}
                    onHide={() => {
                        handleAlertHide(el, idx);
                    }}
                >
                    <Modal.Body className="text-center" style={{lineHeight: 1.2}}>
                        {el.msg}
                    </Modal.Body>
                    <Modal.Footer>
                        {
                            el.btn2Text &&
                            <Button variant="secondary"
                            onClick={() => {
                                el.onClickBtn2();
                                dispatch(hidePopup(idx));
                            }}>
                                {el.btn2Text}
                            </Button>
                        }
                        <Button variant="primary"
                        onClick={() => {
                            handleAlertHide(el, idx);
                        }}>
                            {el.btnText}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        })
    )
}
export default Popup